import { AuthService } from 'src/app/core/services/auth.service';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ContentsService } from 'src/app/core/services/contents.service';
import { UploadPublicationComponent } from '../upload-publication/upload-publication.component';
import { ErrorMessageComponent } from '../../all-modals/error-message/error-message.component';
import { LITERALS } from 'src/app/core/constants/literals.constant';
import { CancelSubscriptionComponent } from '../../subscription-plans/cancel-subscription/cancel-subscription.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-content-type-selector',
  templateUrl: './content-type-selector.component.html',
  styleUrls: ['./content-type-selector.component.scss']
})
export class ContentTypeSelectorComponent implements OnInit {

  currentUser: any;
  type = 'free';
  @Input() public fromModule;
  @Input() public publication_text;
  @Input() public selectedTemplate;

  constructor(
    private activeModal: NgbActiveModal,
    private contentsService: ContentsService,
    private modalService: NgbModal,
    private _authService: AuthService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.currentUser = this._authService.getCurrentUser();
    this.getUserData();
  }

  closeDialog() {
    this.activeModal.close();
  }

  getUserData() {
    this._authService.getCurrentUserData(this.currentUser.user.id).subscribe(
      (response: any) => {
        if (response.success) {
          this.currentUser.user = response.data.user;
        }
      });
  }

  openUploadModal() {
    let paidPlan = false;
    if (this.type == 'paid') {
      paidPlan = true;
      if (this.currentUser.user.verification == null || this.currentUser.user.verification.is_verified == 'rejected') {

        if (this.currentUser.user.verification && this.currentUser.user.verification.is_verified == 'rejected') {
          const modalRef = this.modalService.open(CancelSubscriptionComponent, { centered: true });
          modalRef.componentInstance.forStatus = 'content-upload';
          modalRef.result.then((result) => {
            if (result)
              this.ngOnInit();
          });
          return;
        }
        else {
          const modalRef = this.modalService.open(ErrorMessageComponent, { centered: true });
          modalRef.componentInstance.message = LITERALS.AUTH.ERROR_MESSAGES.VERIFICATION_PENDING_PAID_CONTENT_UPLOAD;
          return;
        }
      }
      // if (this.currentUser.user.subscription.plan.has_redistribution_system === true && this.currentUser.user.subscription.upgrade_to_sell === false) {
      //   this.spinner.show();
      //   this.planService.getCurrentAddOns("upgrade_to_sell").subscribe(
      //     (response: any) => {
      //       this.spinner.hide();
      //       if (response.data.purchased_add_ons.length && response.data.purchased_add_ons[0].add_on && response.data.purchased_add_ons[0].status == 'inactive') {
      //         const modalRefs = this.modalService.open(UploadSpaceModalComponent, { centered: true, backdrop: 'static' });
      //         modalRefs.componentInstance.contentAccessError = LITERALS.AUTH.ERROR_MESSAGES.BULK_BUYER_SELL_ADDON_EXPIRED;
      //         modalRefs.componentInstance.isRedirectRequired = false;
      //         return;
      //       } else {
      //         const modalRefs = this.modalService.open(UploadSpaceModalComponent, { centered: true });
      //         modalRefs.componentInstance.contentAccessError = LITERALS.AUTH.ERROR_MESSAGES.BULK_BUYER_SELL_ADDON_MISSING;
      //         modalRefs.componentInstance.isRedirectRequired = false;
      //         return;
      //       }

      //     }, (error: any) => {
      //       this.spinner.hide();
      //     }
      //   )
      //   return;
      // }
    }

    this.activeModal.close();
    const modalRef = this.modalService.open(UploadPublicationComponent, {
      size: 'lg',
      centered: true,
      keyboard: false,
      backdrop: 'static'
    });
    modalRef.componentInstance.paidPlan = paidPlan;

    modalRef.componentInstance.fromModule = this.fromModule;
    modalRef.componentInstance.publication_text = this.publication_text;
    modalRef.componentInstance.selectedTemplate = this.selectedTemplate;

    modalRef.result.then(
      (result) => {
        if (result == 'success') {
          this.contentsService.subjectClosed.next('success');
          this.closeDialog();
        }
        else {
          if (this.fromModule == 'wipod') {
            this.router.navigate(['/wipod']);
          }
        }
      });
  }

}
